module.exports = __webpack_public_path__ + "static/media/background.60354d64.png";